"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayer = exports.Video = exports.ReplayIcon = exports.Overlay = exports.FullScreenIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var VideoPlayer = exports.VideoPlayer = _styledComponents["default"].div.withConfig({
  displayName: "styles__VideoPlayer",
  componentId: "sc-1f1c9x4-0"
})(["position:relative;height:100%;width:100%;z-index:0;-webkit-tap-highlight-color:rgba(0,0,0,0);"]);
var Overlay = exports.Overlay = _styledComponents["default"].div.withConfig({
  displayName: "styles__Overlay",
  componentId: "sc-1f1c9x4-1"
})(["width:100%;height:100%;position:absolute;z-index:1;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:rgba(0,0,0,0.5);top:0;right:0;left:0;bottom:0;margin:auto;-webkit-tap-highlight-color:rgba(0,0,0,0);"]);
var Video = exports.Video = _styledComponents["default"].video.withConfig({
  displayName: "styles__Video",
  componentId: "sc-1f1c9x4-2"
})(["position:relative;height:100%;width:100%;background-color:#dfdfdf;box-shadow:inset 1px 0px 13px 8px rgba(183,183,183,0.19);"]);
var ReplayIcon = exports.ReplayIcon = _styledComponents["default"].div.withConfig({
  displayName: "styles__ReplayIcon",
  componentId: "sc-1f1c9x4-3"
})(["color:white;background-color:rgba(255,255,255,0.3);border-radius:100%;padding:16px;"]);
var FullScreenIcon = exports.FullScreenIcon = _styledComponents["default"].div.withConfig({
  displayName: "styles__FullScreenIcon",
  componentId: "sc-1f1c9x4-4"
})(["color:white;position:absolute;bottom:0px;right:0px;padding:16px;"]);
//# sourceMappingURL=styles.js.map